<template>
  <button
    v-tooltip="{ title: tooltip }"
    :class="'btn btn-' + (className ? className : 'primary')"
    :disabled="disabled"
    :aria-label="ariaLabel || (!text && tooltip ? tooltip : undefined)"
    type="button"
    @click="click"
  >
    <FontAwesomeIcon v-if="icon" :icon="'fa-light fa-' + icon" aria-hidden="true" />
    <span v-if="text" :class="icon ? 'ms-2' : ''">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "ButtonComponent",
  props: {
    icon: {
      type: String,
      required: false,
      default: "",
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
    ariaLabel: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["buttonClick"],
  methods: {
    click() {
      this.$emit("buttonClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  min-height: 40px;
  svg {
    width: 15px !important;
    height: 15px !important;
  }
  &-neutral {
    @include dark-theme {
      background-color: #7c7e85;
    }
  }
}
</style>
